//import Cookies from 'universal-cookie';
import {getCacheValuebyKey} from './../service/apiService'

var MP={
  // <!-- mp_trans_disable_start --> 
  Version: '1.0.22',
  Domains: {'es':'espanol.verizon.com'},	
  SrcLang: 'en',
// <!-- mp_trans_disable_end -->
  UrlLang: 'mp_js_current_lang',
  SrcUrl: unescape('mp_js_orgin_url'),
// <!-- mp_trans_disable_start --> 	
  init: function(){
    if (MP.UrlLang.indexOf('p_js_')===1) {      
      let domain=(function(a){var b=a.match("[^.]+.(([^.]{2,3}.)?[^.]{2}|[^.]{3,})$");return b==null?a:b[0]})(window.location.host);
      if ((typeof MP !== 'undefined') && (typeof MP.setCookie !== 'undefined')){
              if(window.location.href.indexOf('qualification')===-1)
                //MP.setCookie('persitsetitem', 'Y', '/', domain);                       
                window.sessionStorage.setItem('persist:root',"")
            }
      if(MP.SrcUrl===undefined){
            MP.SrcUrl=window.location.href;
          }
      //MP.SrcUrl="https://www98.verizon.com/inhome/qualification";
      MP.UrlLang=MP.SrcLang;
  }
},
getCookie: function(name){
  var start=document.cookie.indexOf(name+'=');
  if(start < 0) return null;
  start=start+name.length+1;
  var end=document.cookie.indexOf(';', start);
  if(end < 0) end=document.cookie.length;
  while (document.cookie.charAt(start)===' '){ start++; }
  return unescape(document.cookie.substring(start,end));
},
setCookie: function(name,value,path,domain){  
  var cookie=name+'='+escape(value);
  if(path)cookie+='; path='+path;
  if(domain)cookie+='; domain='+domain;
  var now=new Date();
  now.setTime(now.getTime()+1000*60*60*24*365);
  cookie+='; expires='+now.toUTCString();
  document.cookie=cookie;
},
switchLanguage: function(lang){
  if(lang!==MP.SrcLang){
    var script=document.createElement('SCRIPT');
    script.src=window.location.protocol+'//'+MP.Domains[lang]+'/'+MP.SrcLang+lang+'/?1023749632;'+encodeURIComponent(MP.SrcUrl);
    document.body.appendChild(script);
  } else if(lang===MP.SrcLang && MP.UrlLang!==MP.SrcLang){
    script=document.createElement('SCRIPT');
    //script.src=window.location.protocol+'//'+MP.Domains[MP.UrlLang]+'/'+MP.SrcLang+MP.UrlLang+'/?1023749634;'+encodeURIComponent(window.top.document.location.href);
    script.src=window.location.protocol+'//'+MP.Domains[MP.UrlLang]+'/'+MP.SrcLang+MP.UrlLang+'/?1023749634;'+encodeURIComponent(MP.SrcUrl);
    document.body.appendChild(script);
  }
  //MP.switchToLang(script.src);
  //MP.switchToLang(MP.UrlLang==lang?'en':lang);
  return false;
},
switchToLang: function(url) {
  window.location.href=url; 
}
// <!-- mp_trans_disable_end -->   
}

export default MP;





  export const  MP_const = {
  // <!-- mp_trans_disable_start --> 
    Version: '1.0.22',
    Domains: {'es':'espanol.verizon.com'},	
    SrcLang: 'en',
  // <!-- mp_trans_disable_end -->
    UrlLang: 'mp_js_current_lang',
    SrcUrl: unescape('mp_js_orgin_url'),
  // <!-- mp_trans_disable_start --> 	
    init: function(){      
      if (MP.UrlLang.indexOf('p_js_')===1) {
        let domain=(function(a){var b=a.match("[^.]+.(([^.]{2,3}.)?[^.]{2}|[^.]{3,})$");return b==null?a:b[0]})(window.location.host);
        if ((typeof MP !== 'undefined') && (typeof MP.setCookie !== 'undefined')){
                if(window.location.href.indexOf('qualification')===-1)
                 // MP.setCookie('persitsetitem', 'Y', '/', domain);                                                       
                window.sessionStorage.setItem('persist:root',"")
            }
      if(MP.SrcUrl===undefined){
            MP.SrcUrl=window.location.href;
          }
       
        //MP.SrcUrl="https://www98.verizon.com/inhome/qualification";
        MP.UrlLang=MP.SrcLang;
    }
  },
  getCookie: function(name){
    var start=document.cookie.indexOf(name+'=');
    if(start < 0) return null;
    start=start+name.length+1;
    var end=document.cookie.indexOf(';', start);
    if(end < 0) end=document.cookie.length;
    while (document.cookie.charAt(start)===' '){ start++; }
    return unescape(document.cookie.substring(start,end));
  },
  setCookie: function(name,value,path,domain){
    var cookie=name+'='+escape(value);
    if(path)cookie+='; path='+path;
    if(domain)cookie+='; domain='+domain;
    var now=new Date();
    now.setTime(now.getTime()+1000*60*60*24*365);
    cookie+='; expires='+now.toUTCString();
    document.cookie=cookie;
  },
    switchLanguage: function (lang, visit_id, visitor_id) {
      var data = "";
      if (lang !== MP.SrcLang) {
        var script = document.createElement('SCRIPT');
        script.src = window.location.protocol + '//' + MP.Domains[lang] + '/' + MP.SrcLang + lang + '/?1023749632;' + encodeURIComponent(MP.SrcUrl);
        //document.body.appendChild(script);
        document.getElementsByTagName('head')[0].appendChild(script);
      } else if (lang === MP.SrcLang && MP.UrlLang !== MP.SrcLang) {
        script = document.createElement('SCRIPT');
        script.src = window.location.protocol + '//' + MP.Domains[MP.UrlLang] + '/' + MP.SrcLang + MP.UrlLang + '/?1023749634;' + encodeURIComponent(MP.SrcUrl);
        //document.body.appendChild(script);
        document.getElementsByTagName('head')[0].appendChild(script);
      }
      if(window.location.href.includes('fiosreferral') && window.location.href.includes('espanol')){
        window.location.href='https://www.verizon.com/inhome/fiosreferral';
      }
      MP_const.switchToLang(MP.SrcUrl);
      return false;
    },
  switchToLang: function(url) {
    window.location.href=url; 
  },

  switchToEspana: function(lang) {
    //lang='enes';
    //var langPair=lang;
    var url=window.location.href;
    //url="https://www98.verizon.com/inhome/qualification";
    var u=decodeURIComponent(url);
    //var u=decodeURIComponent('https://espanol.verizon.com/foryourhome/ordering/checkavailabilitylq.aspx');
    var domain=(function(a){var b=a.match("[^.]+.(([^.]{2,3}.)?[^.]{2}|[^.]{3,})$");return b==null?a:b[0]})(window.location.host);
    if ((typeof MP !== 'undefined') && (typeof MP.setCookie !== 'undefined'))
    {
        MP.setCookie('MP_LANG', lang, '/', domain);
    }
       MP.switchToLang(u);
    },
  // <!-- mp_trans_disable_end -->   
  };

  